<template>
    <div style="height: 100%">
        <v-row style="height: 100%">
            <v-col
                cols="12"
                md="4"
            >
                <info v-if="schedule" :schedule="schedule"/>
            </v-col>
            <v-col>
                <gatewaysTable v-if="schedule" :schedule="schedule"/>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import info from '../components/Schedule/info'
import gatewaysTable from '../components/Schedule/gateways'

export default {
    name: 'Name',
    components: { info, gatewaysTable },
    computed:{
        ...mapState({ 
            schedule(state){
                return state.schedules.schedules.find( s => s.id == this.$route.params.id )
            }
        })
    },
    data() {
        return {
            
        }
    },
}
</script>